define('models/TagCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/TagModel'], function (_, ObjectCollection, LocalStorage, TagModel)
{
    //
    // Collection Tag
    //
    var TagCollectionPrototype = {

        name: 'TagModelCollection',
        route: 'apiTagCollection',
        model: TagModel,
        initialize: function ()
        {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);

        },

        whereIds:function(ids){
            var collection = new TagCollection();
            collection.reset();
            this.each(function (tagModel)
            {
                if ((_(ids).indexOf(tagModel.get('id_tag')) >= 0)) {
                    collection.add(tagModel)
                }
            });
            return collection;
        },

        isAllChecked:function(){
            var allChecked = true;
            this.each(function(model){
                allChecked = allChecked && model.isChecked()
            });
            return allChecked;
        },

        isNoneChecked:function(){
            var noneChecked = true;
            this.each(function(model){
                noneChecked = noneChecked && !model.isChecked()
            });
            return noneChecked;
        },

        isFilterChecked:function(){
            return !(this.isNoneChecked() || this.isAllChecked());
        },

        getChecked:function(){
            return new TagCollection(this.filter(function(model){
                return model.isChecked();
            }));
        },

        getCheckedCount:function(){
            var collection = this;
            return collection.isFilterChecked() ? collection.getChecked().length : 0;
        },
    };

    var TagCollection = ObjectCollection.extend(LocalStorage).extend(TagCollectionPrototype);

    return TagCollection;
});
